<template>
  <div class="main-container">
    <div class="search">
      <div class="item">
        <label class="label">上课时间：</label>
        <el-select
          v-model="is_next"
          placeholder="请选择"
          @change="onWeekChange"
          filterable
        >
          <el-option label="本周" :value="0"></el-option>
          <el-option label="下周" :value="1"></el-option>
        </el-select>
        <el-time-picker
          v-model="search.beginTime"
          placeholder="开始时间"
          format="HH:mm"
          value-format="HH:mm"
          @change="timeChange"
        ></el-time-picker>
        <span>-</span>
        <el-time-picker
          v-model="search.endTime"
          placeholder="结束时间"
          format="HH:mm"
          value-format="HH:mm"
          :minTime="search.beginTime"
          @change="timeChange"
        ></el-time-picker>
      </div>
      <div class="item clear">
        <label class="label">老师类型：</label>
        <el-radio-group v-model="search.level" @change="getTeacher">
          <el-radio
            :label="level.level_id"
            v-for="level in levels"
            :key="level.level_id"
          >
            {{ level.level_name }}
          </el-radio>
        </el-radio-group>
      </div>
      <div class="item" v-for="attr in attrs" :key="attr.attr_id">
        <label class="label" :title="attr.attr_name">
          {{ attr.attr_name }}：
        </label>
        <el-radio-group
          v-model="search.attr[attr.attr_id]"
          @change="getTeacher"
        >
          <el-radio
            :label="item.attr_val_id"
            v-for="item in attr.child"
            :key="item.attr_val_id"
          >
            {{ item.attr_val_name }}
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="main-content clear">
      <div class="teacher f-left">
        <div>
          <div class="search-warp">
            <div class="search-box">
              <input
                class="search-input"
                type="text"
                v-model="search.teacher_name"
                placeholder="输入老师名称"
                @keydown.enter="getTeacher"
              />
              <span class="search-btn">
                <img
                  class="search-btn-img"
                  src="@/assets/images/common/search@3x.png"
                  alt="搜索"
                  @click="getTeacher"
                />
              </span>
            </div>
            <a @click="getTeacher">搜索</a>
          </div>
          <div class="items" v-if="teachers.length > 0">
            <div
              class="item-wrap"
              :class="{ current: teacherId == teacher.teacher_id }"
              v-for="teacher in teachers"
              :key="teacher.teacher_id"
            >
              <div class="radius-wrap radius-wrap-right-top">
                <div class="radius"></div>
              </div>
              <div class="item" @click="changeTeacher(teacher.teacher_id)">
                <img class="avatar" :src="teacher.avatar" />
                <div class="main">
                  <div class="title" :title="teacher.real_name">
                    {{ teacher.real_name }}
                  </div>
                  <div class="intro">
                    <span>{{ teacher.sex | sex }}</span>
                    <span>{{ teacher.age }}岁</span>
                    <span>{{ teacher.teach_age }}年教龄</span>
                  </div>
                </div>
                <router-link
                  :to="{
                    name: 'OtoTeacherShow',
                    params: { id: teacher.teacher_id },
                  }"
                >
                  详情
                </router-link>
              </div>
              <div class="radius-wrap radius-wrap-right-bottom">
                <div class="radius"></div>
              </div>
            </div>
          </div>
          <div class="pager clear" v-if="teachers.length > 0">
            <a class="left-2" :disabled="page <= 1" @click="goToPage(1)"></a>
            <a
              class="left"
              :disabled="page <= 1"
              @click="goToPage(page - 1)"
            ></a>
            <span>{{ page }}/{{ totalPage }}</span>
            <a
              class="right"
              :disabled="page >= totalPage"
              @click="goToPage(page + 1)"
            ></a>
            <a
              class="right-2"
              :disabled="page >= totalPage"
              @click="goToPage(totalPage)"
            ></a>
          </div>
          <div class="jump" v-if="teachers.length > 0">
            <span>跳转至</span>
            <el-input v-model="jumpPage"></el-input>
            <span>页</span>
            <a @click="jump">跳转</a>
          </div>
        </div>
        <div class="empty center" v-if="teachers.length == 0">
          <img src="@/assets/images/oto/empty@3x.png" style="width: 48px" />
          <div>该时段暂无老师～</div>
        </div>
      </div>
      <div class="f-left oto-table-wrap">
        <OtoScheduleTable
          :teacherId="teacherId.toString()"
          :is_next="is_next"
          class="oto-table"
        ></OtoScheduleTable>
      </div>
    </div>
    <el-dialog
      :visible.sync="showSelectDate"
      width="500"
      center
      :show-close="false"
    >
      <table class="table-date">
        <thead>
          <tr>
            <th></th>
            <th>一</th>
            <th>二</th>
            <th>三</th>
            <th>四</th>
            <th>五</th>
            <th>六</th>
            <th>日</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>本周</td>
            <td
              :class="{
                disabled: date.format('yyyy-MM-dd') < today,
                today: date.format('yyyy-MM-dd') == today,
                date: date.format('yyyy-MM-dd') >= today,
                selected: date.format('yyyy-MM-dd') == search.date,
              }"
              v-for="(date, index) in thisWeekDates"
              :key="index"
              @click="selectDate(date.format('yyyy-MM-dd'), 0)"
            >
              {{ date.format("MM-dd") }}
            </td>
          </tr>
          <tr>
            <td>下周</td>
            <td
              :class="{
                disabled: date.format('yyyy-MM-dd') < today,
                today: date.format('yyyy-MM-dd') == today,
                date: date.format('yyyy-MM-dd') >= today,
                selected: date.format('yyyy-MM-dd') == search.date,
              }"
              v-for="(date, index) in nextWeekDates"
              :key="index"
              @click="selectDate(date.format('yyyy-MM-dd'), 1)"
            >
              {{ date.format("MM-dd") }}
            </td>
          </tr>
        </tbody>
      </table>
      <span slot="footer" class="dialog-footer">
        <a class="lnk-today" @click="selectDate(today)">今天</a>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import OtoScheduleTable from "../../components/OtoScheduleTable.vue";

export default {
  name: "Oto",
  components: {
    OtoScheduleTable,
  },
  data() {
    return {
      search: {
        teacher_name: this.$route.query.keywords,
        beginDate: "",
        endDate: "",
        level: 0,
        attr: {},
        is_collect: false,
        is_attended: false,
        beginTime: "",
        endTime: "",
        sex: -1,
      },
      levels: [],
      attrs: [],
      showSelectDate: false,
      today: new Date().format("yyyy-MM-dd"),
      thisWeekDates: [],
      nextWeekDates: [],
      teachers: [],
      teacherId: 0,
      timer: 0,
      page: 1,
      limit: 5,
      total: 0,
      totalPage: 0,
      jumpPage: "",
      is_next: 0,
    };
  },
  watch: {
    async $route() {
      this.search.teacher_name = this.$route.query.keywords;
      await this.getTeacher();
    },
  },
  async created() {
    let data = await this.$http.get("/api/app/otoCourseOptions");
    this.levels = data.otoTeacherLevel;
    this.levels.unshift({
      level_id: 0,
      level_name: "全部",
    });
    this.attrs = data.attrList || [];
    this.attrs.forEach(a => {
      this.$set(this.search.attr, a.attr_id, 0);
      a.child.unshift({
        attr_val_id: 0,
        attr_val_name: "全部",
      });
    });
    this.getDates(0);
    await this.getTeacher();
  },
  methods: {
    async onWeekChange() {
      this.getDates(this.is_next);
      await this.getTeacher();
    },
    getDates(isNext) {
      let date = new Date();
      let weekDay = date.getDay();
      let beginDate = [];
      if (weekDay == 0) {
        beginDate = date.getDate() - 6;
      } else {
        beginDate = date.getDate() - (weekDay - 1);
      }
      if (isNext == 1) {
        beginDate = beginDate + 7;
      }
      let dates = [];
      for (let i = 0; i <= 6; i++) {
        let date = new Date();
        date.setDate(beginDate + i);
        dates.push(date);
      }
      this.search.beginDate = dates[0].format("yyyy-MM-dd");
      this.search.endDate = dates[6].format("yyyy-MM-dd");
    },
    async selectDate(date, is_next) {
      if (date < this.today) {
        return;
      }
      this.is_next = is_next;
      this.search.date = date;
      this.showSelectDate = false;
      await this.getTeacher();
    },
    async timeChange() {
      await this.getTeacher();
    },
    async getTeacher() {
      let params = {
        level_id: this.search.level,
        is_collect: this.search.is_collect ? 1 : 0,
        is_attended: this.search.is_attended ? 1 : 0,
        teacher_name: this.search.teacher_name,
        page: this.page,
        limit: this.limit,
      };
      if (this.search.beginDate != "") {
        params.start_time = this.search.beginDate;
        if (this.search.beginTime) {
          params.start_time += " " + this.search.beginTime;
        }
      }
      if (this.search.endDate != "") {
        params.end_time = this.search.endDate;
        if (this.search.endTime) {
          params.end_time += " " + this.search.endTime;
        } else {
          params.end_time += " 23:59";
        }
      }
      if (this.search.sex != -1) {
        params.sex = this.search.sex;
      }
      let attrIds = [];
      for (let key in this.search.attr) {
        let valId = this.search.attr[key];
        if (valId != 0) {
          attrIds.push(valId);
        }
      }
      params.attr_val_id = attrIds.join(",");
      let data = await this.$http.get("/api/app/otoCourse", params);
      this.teachers = data.data;
      this.teacherId = 0;
      if (data.data.length > 0) {
        this.changeTeacher(data.data[0].teacher_id);
      }
      let totalPage = parseInt(data.total / this.limit);
      if (data.total % this.limit > 0) {
        totalPage++;
      }
      this.totalPage = totalPage;
    },
    async changeTeacher(id) {
      this.teacherId = id;
    },
    async toggleCollect(teacher) {
      await this.$http.get(
        "/api/app/teacher/collect/" + teacher.teacher_id,
        {},
        true,
      );
      let is_collect = teacher.is_collect == 0 ? 1 : 0;
      if (is_collect == 1) {
        await this.$success("收藏成功");
      } else {
        await this.$success("取消收藏成功");
      }
      teacher.is_collect = is_collect;
    },
    async goToPage(page) {
      if (page <= 0 || page > this.totalPage || page == this.page) {
        return;
      }
      this.page = page;
      await this.getTeacher();
    },
    async jump() {
      if (!/[0-9]+/.test(this.jumpPage)) {
        this.$info("请输入正整数");
        return;
      }
      if (this.jumpPage > this.totalPage) {
        this.$info("不得大于" + this.totalPage);
        return;
      }
      if (this.jumpPage < 1) {
        this.$info("必须大于0");
        return;
      }
      this.page = this.jumpPage;
      await this.getTeacher();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/oto.scss";
</style>
